<template>
  <div class="filter">
    <!-- Title  & reset button -->
    <div class="title">
      <b>{{ name }}</b>
      <a @click="reset">Reset</a>
    </div>

    <!-- List of options -->
    <ul class="options">
      <!-- Show all options -->
      <li class="option">
        <label :for="`_${name.toLowerCase()}`"> All {{ name }}</label>
        <input
          type="checkbox"
          v-model="_showAll"
          :id="`_${name.toLowerCase()}`"
        />
      </li>

      <!-- Individual options -->
      <li v-for="option in options" :key="option.key" class="option">
        <label :for="option.key" :class="{ disable: _showAll }">
          {{ option.value }}</label
        >
        <input
          type="checkbox"
          class="option"
          v-model="_checkedOptions"
          :value="option.key"
          :id="option.key"
          :disabled="_showAll"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FilterBox",
  props: {
    name: {
      type: String,
      required: true,
      default: "Options",
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    checkedOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    showAll: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    _showAll: {
      get() {
        return this.showAll;
      },
      set(value) {
        this.$emit("update:showAll", value);
      },
    },
    _checkedOptions: {
      get() {
        return this.checkedOptions;
      },
      set(value) {
        this.$emit("update:checkedOptions", value);
      },
    },
  },
  methods: {
    reset() {
      this._showAll = true;
      this._checkedOptions = [];
    },
  },
};
</script>

<style>
.filter {
  margin: 0.5rem 0rem;
  font-weight: 400;
  color: darkslategray;
}

.filter .title {
  margin: 0;
  padding: 0 0.2rem;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.filter .title a {
  font-size: smaller;
  color: darkgray;
  cursor: pointer;
}

.filter .title a:hover {
  font-size: smaller;
  color: darkslateblue;
}

.filter .options {
  margin: 0;
  padding: 0.25rem 0;
}

.filter .options li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
}

.filter .options li:hover {
  color: rgb(50, 116, 181);
}

.filter .options li label {
  cursor: pointer;
  flex: 1;
  padding: 0.2rem;
  margin: 0;
}

.filter .options li input {
  cursor: pointer;
  margin: 0;
  margin-right: 0.2rem;
  padding: 0.2rem;
}

.filter .options li label.disable {
  color: gray;
  cursor: default;
}
</style>
